import { BasicClient } from '@/utils/httpClient';

export default class Signatures {
    client;
    constructor() {
        this.client = new BasicClient();
    }

    documentSignature(idapp, iddoc, body){
        return this.client.exec(`documents/sign/${idapp}/${iddoc}/0`, 'PATCH', body);
    }
    dissatisfiedDocumentSignature(idapp, iddoc, body, reason){
        return this.client.exec(`documents/sign/${idapp}/${iddoc}/${reason}`, 'PATCH', body);
    }
    consultRRHHOnSign(idapp, iddoc, message){
        let body = {
            comment: message
        }
        return this.client.exec(`/documents/question/${idapp}/${iddoc}`, 'PUT', body)
    }
}